// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1Cyph","bigColWidth":"Table_bigColWidth__1bDAF","biggerColWidth":"Table_biggerColWidth__2619d","row":"Table_row__1Ex7L","col":"Table_col__DErlf"};